import { render } from "./ReportView.vue?vue&type=template&id=0c52852d&scoped=true&ts=true"
import script from "./ReportView.vue?vue&type=script&lang=ts"
export * from "./ReportView.vue?vue&type=script&lang=ts"

import "./ReportView.vue?vue&type=style&index=0&id=0c52852d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c52852d"]])

export default __exports__